import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Card } from "../components/ui/card";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Signed in");
      const next = loc.state?.from || (u.role === "admin" ? "/admin" : "/dashboard");
      nav(next);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <Card className="card-elevated w-full max-w-md p-8">
        <div className="overline"><span className="accent-line" /> Welcome back</div>
        <h1 className="font-display text-3xl mt-3">Sign in to BizPulse AI</h1>
        <form className="mt-7 space-y-4" onSubmit={submit}>
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-2" placeholder="you@firm.com" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-2" placeholder="••••••••" />
          </div>
          <Button type="submit" data-testid="login-submit" disabled={busy} className="w-full bg-accent text-accent-foreground hover:bg-accent/90">
            {busy ? "Signing in…" : "Sign in"}
          </Button>
          <div className="text-right">
            <Link to="/forgot-password" className="text-xs text-muted-foreground hover:text-accent" data-testid="login-forgot-link">
              Forgot your password?
            </Link>
          </div>
        </form>
        <p className="text-sm text-muted-foreground mt-6 text-center">
          New to BizPulse? <Link to="/register" className="text-accent hover:underline" data-testid="login-register-link">Create an account</Link>
        </p>
        <p className="text-xs text-muted-foreground mt-3 text-center">
          Admin sign-in available with seeded credentials.
        </p>
      </Card>
    </div>
  );
}
